<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  (validate)="onValidate($event)"
>
  <div>
    <h1 class="section-header">Individual Summary</h1>
    <hr />
    <nh-table
      [columns]="individualSummaryColumns"
      [sectionId]="'PRASM'"
      [rows]="individualSummaryResults"
      [mode]="mode"
      (edit)="onIndividualRowEdit($event)"
      (delete)="onIndividualRowDelete($event)"
    >
    </nh-table>

    <div class="pt-1 hover-red">
      <a
        class="btn btn-link btn-lg hover-red"
        tabindex="0"
        (click)="addIndividual()"
      >
        <span class="pe-2">Add Another Person</span>
        <svg
          id="_icons_add-circle-outline"
          data-name="⚛️ icons/add-circle-outline"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            id="Combined_Shape"
            data-name="Combined Shape"
            d="M0,9.75A9.75,9.75,0,1,1,9.75,19.5,9.761,9.761,0,0,1,0,9.75Zm1.5,0A8.25,8.25,0,1,0,9.75,1.5,8.259,8.259,0,0,0,1.5,9.75ZM9,13.514V10.5H6A.75.75,0,0,1,5.985,9H9V6a.75.75,0,0,1,1.5-.015V9h3a.75.75,0,0,1,.014,1.5H10.5v3a.75.75,0,0,1-1.5.014Z"
            transform="translate(2.25 2.25)"
            fill="#174a7c"
          />
        </svg>
      </a>
    </div>
  </div>
  <br />
  <br />

  @if (showRelationships) {
  <div>
    <h2 class="section-header">Relationships Summary</h2>
    <hr />
    <div>
      <nh-table
        [columns]="relationshipSummaryColumns"
        [sectionId]="'PRASM'"
        [rows]="relationshipSummaryResults"
        [mode]="mode"
        (edit)="onRelationshipsRowEdit()"
      >
      </nh-table>
    </div>
  </div>
  }
  <br />
  <br />
  <div>
    <h2 class="section-header">Other Health Insurance Summary</h2>
    <hr />
    <div>
      @if (!showOtherHealthInsurance) {
      <p>
        You haven't told us about any Other Health Insurance for your household.
      </p>
      } @if (showOtherHealthInsurance) {
      <nh-table
        [columns]="otherHealthInsuranceSummaryColumns"
        [sectionId]="'PRASM'"
        [rows]="otherHealthInsuranceSummaryResults"
        [mode]="mode"
        (edit)="onOtherHealthInsuranceRowEdit($event)"
        (delete)="onOtherHealthInsuranceRowDelete($event)"
      >
      </nh-table>
      }
    </div>
  </div>
  <br />
  <br />

  <div>
    <h2 class="section-header">Tax Information Summary</h2>
    <hr />
    <div>
      @if (!showTaxSummary) {
      <p>You haven't told us about any Tax Information for your household.</p>
      } @if (showTaxSummary) {
      <nh-table
        [columns]="taxInformationSummaryColumns"
        [sectionId]="'PRASM'"
        [rows]="taxInformationSummaryResults"
        [mode]="mode"
        (edit)="taxInformationRowEdit()"
        (delete)="taxInformationRowDelete($event)"
      >
      </nh-table>
      }
    </div>
  </div>
  <br />
  <br />

  <div>
    <h2 class="section-header">Earned Income Summary</h2>
    <hr />
    <div>
      @if (earnedIncomeSummaryResults?.length == 0) {
      <p>You haven't told us about any Earned Income for your household.</p>
      } @if (earnedIncomeSummaryResults?.length != 0) {
      <nh-table
        [columns]="earnedIncomeSummaryColumns"
        [sectionId]="'PRASM'"
        [rows]="earnedIncomeSummaryResults"
        [mode]="mode"
        (edit)="earnedIncomeRowEdit()"
        (delete)="earnedIncomeRowDelete($event)"
      >
      </nh-table>
      }
    </div>

    @if (earnedIncomeSummaryResults?.length != 0) {
    <div class="pt-1 hover-red">
      <a
        class="btn btn-link btn-lg hover-red"
        tabindex="0"
        (click)="addIncomeDetails()"
      >
        <span class="pe-2">Add Another</span>
        <svg
          id="_icons_add-circle-outline"
          data-name="⚛️ icons/add-circle-outline"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            id="Combined_Shape"
            data-name="Combined Shape"
            d="M0,9.75A9.75,9.75,0,1,1,9.75,19.5,9.761,9.761,0,0,1,0,9.75Zm1.5,0A8.25,8.25,0,1,0,9.75,1.5,8.259,8.259,0,0,0,1.5,9.75ZM9,13.514V10.5H6A.75.75,0,0,1,5.985,9H9V6a.75.75,0,0,1,1.5-.015V9h3a.75.75,0,0,1,.014,1.5H10.5v3a.75.75,0,0,1-1.5.014Z"
            transform="translate(2.25 2.25)"
            fill="#174a7c"
          />
        </svg>
      </a>
    </div>
    }
  </div>

  <br />
  <br />

  <div>
    <h2 class="section-header">Self-Employment Income Summary</h2>
    <hr />
    <div>
      @if (selfEmploymentIncomeSummaryResults?.length == 0) {
      <p>
        You haven't told us about any Self-Employment Income for your household.
      </p>
      } @if (selfEmploymentIncomeSummaryResults?.length != 0) {
      <nh-table
        [columns]="selfEmploymentIncomeSummaryColumns"
        [sectionId]="'PRASM'"
        [rows]="selfEmploymentIncomeSummaryResults"
        [mode]="mode"
        (edit)="selfEmploymentRowEdit()"
        (delete)="selfEmploymentRowDelete($event)"
      >
      </nh-table>
      }
    </div>

    @if (selfEmploymentIncomeSummaryResults?.length != 0) {
    <div class="pt-1 hover-red">
      <a
        class="btn btn-link btn-lg hover-red"
        tabindex="0"
        (click)="addIncomeDetails()"
      >
        <span class="pe-2">Add Another</span>
        <svg
          id="_icons_add-circle-outline"
          data-name="⚛️ icons/add-circle-outline"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            id="Combined_Shape"
            data-name="Combined Shape"
            d="M0,9.75A9.75,9.75,0,1,1,9.75,19.5,9.761,9.761,0,0,1,0,9.75Zm1.5,0A8.25,8.25,0,1,0,9.75,1.5,8.259,8.259,0,0,0,1.5,9.75ZM9,13.514V10.5H6A.75.75,0,0,1,5.985,9H9V6a.75.75,0,0,1,1.5-.015V9h3a.75.75,0,0,1,.014,1.5H10.5v3a.75.75,0,0,1-1.5.014Z"
            transform="translate(2.25 2.25)"
            fill="#174a7c"
          />
        </svg>
      </a>
    </div>
    }
  </div>

  <br />
  <br />

  <div>
    <h2 class="section-header">Other Income Summary</h2>
    <hr />
    <div>
      @if (otherIncomeSummaryResults?.length == 0) {
      <p>You haven't told us about any Other Income for your household.</p>
      } @if (otherIncomeSummaryResults?.length != 0) {
      <nh-table
        [columns]="otherIncomeSummaryColumns"
        [sectionId]="'PRASM'"
        [rows]="otherIncomeSummaryResults"
        [mode]="mode"
        (edit)="otherIncomeRowEdit()"
        (delete)="otherIncomeRowDelete($event)"
      >
      </nh-table>
      }
    </div>

    @if (otherIncomeSummaryResults?.length != 0) {
    <div class="pt-1 hover-red">
      <a
        class="btn btn-link btn-lg hover-red"
        tabindex="0"
        (click)="addIncomeDetails()"
      >
        <span class="pe-2">Add Another</span>
        <svg
          id="_icons_add-circle-outline"
          data-name="⚛️ icons/add-circle-outline"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            id="Combined_Shape"
            data-name="Combined Shape"
            d="M0,9.75A9.75,9.75,0,1,1,9.75,19.5,9.761,9.761,0,0,1,0,9.75Zm1.5,0A8.25,8.25,0,1,0,9.75,1.5,8.259,8.259,0,0,0,1.5,9.75ZM9,13.514V10.5H6A.75.75,0,0,1,5.985,9H9V6a.75.75,0,0,1,1.5-.015V9h3a.75.75,0,0,1,.014,1.5H10.5v3a.75.75,0,0,1-1.5.014Z"
            transform="translate(2.25 2.25)"
            fill="#174a7c"
          />
        </svg>
      </a>
    </div>
    }
  </div>

  <br />
  <br />

  <div>
    <h2 class="section-header">Tax Deductions Summary</h2>
    <hr />
    <div>
      @if (taxDeductionsSummaryResults?.length == 0) {
      <p>You haven't told us about any Deductions for your household.</p>
      } @if (taxDeductionsSummaryResults?.length != 0) {
      <nh-table
        [columns]="taxDeductionsSummaryColumns"
        [sectionId]="'PRASM'"
        [rows]="taxDeductionsSummaryResults"
        [mode]="mode"
        (edit)="taxDeductionsRowEdit()"
        (delete)="taxDeductionsRowDelete($event)"
      >
      </nh-table>
      }
    </div>

    @if (taxDeductionsSummaryResults?.length != 0) {
    <div class="pt-1 hover-red">
      <a
        class="btn btn-link btn-lg hover-red"
        tabindex="0"
        (click)="addIncomeDetails()"
      >
        <span class="pe-2">Add Another</span>
        <svg
          id="_icons_add-circle-outline"
          data-name="⚛️ icons/add-circle-outline"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            id="Combined_Shape"
            data-name="Combined Shape"
            d="M0,9.75A9.75,9.75,0,1,1,9.75,19.5,9.761,9.761,0,0,1,0,9.75Zm1.5,0A8.25,8.25,0,1,0,9.75,1.5,8.259,8.259,0,0,0,1.5,9.75ZM9,13.514V10.5H6A.75.75,0,0,1,5.985,9H9V6a.75.75,0,0,1,1.5-.015V9h3a.75.75,0,0,1,.014,1.5H10.5v3a.75.75,0,0,1-1.5.014Z"
            transform="translate(2.25 2.25)"
            fill="#174a7c"
          />
        </svg>
      </a>
    </div>
    }
  </div>

  <br />
  <br />

  @if (otherQuestionsSummaryResults?.length > 0) {
  <div>
    <h2 class="section-header">Other Questions Summary</h2>
    <hr />
    <div>
      <nh-table
        [columns]="otherQuestionsSummaryColumns"
        [sectionId]="'PRASM'"
        [rows]="otherQuestionsSummaryResults"
        [mode]="mode"
        (edit)="otherQuestionRowEdit()"
        (delete)="otherQuestionRowDelete($event)"
      >
      </nh-table>
    </div>
    @if (otherQuestionsSummaryResults?.length > 1) {
    <div class="pt-1 hover-red">
      <a
        class="btn btn-link btn-lg hover-red"
        tabindex="0"
        (click)="addOtherQuestionDetails()"
      >
        <span class="pe-2">Add Another</span>
        <svg
          id="_icons_add-circle-outline"
          data-name="⚛️ icons/add-circle-outline"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            id="Combined_Shape"
            data-name="Combined Shape"
            d="M0,9.75A9.75,9.75,0,1,1,9.75,19.5,9.761,9.761,0,0,1,0,9.75Zm1.5,0A8.25,8.25,0,1,0,9.75,1.5,8.259,8.259,0,0,0,1.5,9.75ZM9,13.514V10.5H6A.75.75,0,0,1,5.985,9H9V6a.75.75,0,0,1,1.5-.015V9h3a.75.75,0,0,1,.014,1.5H10.5v3a.75.75,0,0,1-1.5.014Z"
            transform="translate(2.25 2.25)"
            fill="#174a7c"
          />
        </svg>
      </a>
    </div>
    }
  </div>
  }
  @if (transferredResIndSw) {
  <br />
<div>
    <h2 class="section-header">Summary of Transferred Resources</h2>
    <hr />
    <div>
      @if (!transferredResourcesSummaryResults || transferredResourcesSummaryResults?.length == 0) {
      <p>
        You haven't told us about any Transferred Resources for your household.
      </p>
      } @if (transferredResourcesSummaryResults && transferredResourcesSummaryResults?.length > 0) {
      <nh-table
        [columns]="transferredResourcesSummaryColumns"
        [sectionId]="'PRASM'"
        [rows]="transferredResourcesSummaryResults"
        [mode]="mode"
      (edit)="onTransferredResourcesRowEdit($event)"
      (delete)="onTransferredResourcesRowDelete($event)"
      >
      </nh-table>
      }
    </div>
  </div>
  <br />
  }
  @if (expensesIndSw) {
  <div>
    <h2 class="section-header">Summary of Shelter or Utility Expense</h2>
    <hr />
    <div>
      @if (!shelterOrUtilityExpenseSummaryResults || shelterOrUtilityExpenseSummaryResults?.length == 0) {
      <p>
        You haven't told us about any Shelter or Utility Expense  for your household.
      </p>
      } @if (shelterOrUtilityExpenseSummaryResults && shelterOrUtilityExpenseSummaryResults?.length != 0) {
      <nh-table
        [columns]="shelterOrUtilityExpenseSummaryColumns"
        [sectionId]="'PRASM'"
        [rows]="shelterOrUtilityExpenseSummaryResults"
        [mode]="mode"
        (edit)="shelterOrUtilityExpenseRowEdit($event)"
        (delete)="shelterOrUtilityExpenseRowDelete($event)"
      >
      </nh-table>
      }
    </div>
  </div>
  <br />
  }
  @if (expensesIndSw) {
  <div>
    <h2 class="section-header">Summary of Dependent Care Expense </h2>
    <hr />
    <div>
      @if (!dependentCareSummaryResults || dependentCareSummaryResults?.length == 0) {
      <p>
        You haven't told us about any Dependent Care Expense for your household.
      </p>
      } @if (dependentCareSummaryResults && dependentCareSummaryResults?.length > 0) {
      <nh-table
        [columns]="dependentCareSummaryColumns"
        [sectionId]="'PRASM'"
        [rows]="dependentCareSummaryResults"
        [mode]="mode"
        (edit)="dependentCareRowEdit($event)"
        (delete)="dependentCareRowDelete($event)"
      >
      </nh-table>
      }
    </div>
  </div>
  <br />
  }
    @if (expensesIndSw) {
    <div>
    <h2 class="section-header">Summary of Mandatory Payments Expense </h2>
    <hr />
    <div>
      @if (!mandatoryPaymentsSummaryResults || mandatoryPaymentsSummaryResults?.length == 0) {
      <p>
        You haven't told us about any Mandatory Payments Expense for your household.
      </p>
      } @if (mandatoryPaymentsSummaryResults && mandatoryPaymentsSummaryResults?.length > 0) {
      <nh-table
        [columns]="mandatoryPaymentsSummaryColumns"
        [sectionId]="'PRASM'"
        [rows]="mandatoryPaymentsSummaryResults"
        [mode]="mode"
        (edit)="onMandatoryPaymentsRowEdit($event)"
        (delete)="onMandatoryPaymentsRowDelete($event)"
      >
      </nh-table>
      }
    </div>
  </div>
  <br />
  }
  @if (expensesIndSw) {
  <div>
    <h2 class="section-header">Summary of Medical Bills </h2>
    <hr />
    <div>
      @if (!medicalBillsSummaryResults || medicalBillsSummaryResults?.length == 0) {
      <p>
        You haven't told us about any Medical Bills for your household.
      </p>
      } @if (medicalBillsSummaryResults && medicalBillsSummaryResults?.length > 0) {
      <nh-table
        [columns]="medicalBillsSummaryColumns"
        [sectionId]="'PRASM'"
        [rows]="medicalBillsSummaryResults"
        [mode]="mode"
        (edit)="onMedicalBillsRowEdit($event)"
        (delete)="onMedicalBillsRowDelete($event)"
      >
      </nh-table>
      }
    </div>
  </div>
  <br />
  }
  @if (expensesIndSw) {
  <div>
    <h2 class="section-header">Summary of Access to Other Coverage </h2>
    <hr />
    <div>
      @if (!accessToOtherCoverageSummaryResults || accessToOtherCoverageSummaryResults?.length == 0) {
      <p>
        You haven't told us about any Access to Other Coverage for your household.
      </p>
      } @if (accessToOtherCoverageSummaryResults && accessToOtherCoverageSummaryResults?.length > 0) {
      <nh-table
        [columns]="accessToOtherCoverageSummaryColumns"
        [sectionId]="'PRASM'"
        [rows]="accessToOtherCoverageSummaryResults"
        [mode]="mode"
        (edit)="onAccessToOtherCoverageRowEdit($event)"
        (delete)="onAccessToOtherCoverageRowDelete($event)"
      >
      </nh-table>
      }
    </div>
  </div>
  <br />
  }
  @if (assetIndSw) {
  <div>
    <h2 class="section-header">Summary of Financial Resources </h2>
    <hr />
    <div>
      @if (!financialResourcesSummaryResults || financialResourcesSummaryResults?.length == 0) {
      <p>
        You haven't told us about any Financial Resources for your household.
      </p>
      } @if (financialResourcesSummaryResults && financialResourcesSummaryResults?.length > 0) {
      <nh-table
        [columns]="financialResourcesSummaryColumns"
        [sectionId]="'PRASM'"
        [rows]="financialResourcesSummaryResults"
        [mode]="mode"
        (edit)="onFinancialResourcesRowEdit($event)"
        (delete)="onFinancialResourcesRowDelete($event)"
      >
      </nh-table>
      }
    </div>
  </div>
  <br />
  }  
  @if (assetIndSw) {
  <div>
    <h2 class="section-header">Summary of Vehicles </h2>
    <hr />
    <div>
      @if (!vehicleSummaryResults || vehicleSummaryResults?.length == 0) {
      <p>
        You haven't told us about any Vehicles for your household.
      </p>
      } @if (vehicleSummaryResults && vehicleSummaryResults?.length > 0) {
      <nh-table
        [columns]="vehicleSummaryColumns"
        [sectionId]="'PRASM'"
        [rows]="vehicleSummaryResults"
        [mode]="mode"
        (edit)="onVehicleRowEdit($event)"
        (delete)="onVehicleRowDelete($event)"
      >
      </nh-table>
      }
    </div>
  </div>
  <br />
  } 
  @if (assetIndSw) {
  <div>
    <h2 class="section-header">Summary of Property </h2>
    <hr />
    <div>
      @if (!propertySummaryResults || propertySummaryResults?.length == 0) {
      <p>
        You haven't told us about any Property for your household.
      </p>
      } @if (propertySummaryResults && propertySummaryResults?.length > 0) {
      <nh-table
        [columns]="propertySummaryColumns"
        [sectionId]="'PRASM'"
        [rows]="propertySummaryResults"
        [mode]="mode"
        (edit)="onPropertyRowEdit($event)"
        (delete)="onPropertyRowDelete($event)"
      >
      </nh-table>
      }
    </div>
  </div>
  <br />
  }
  @if (assetIndSw) {
  <div>
    <h2 class="section-header">Summary of Burial Resources </h2>
    <hr />
    <div>
      @if (!burialResourcesSummaryResults || burialResourcesSummaryResults?.length == 0) {
      <p>
        You haven't told us about any Burial Resources for your household.
      </p>
      } @if (burialResourcesSummaryResults && burialResourcesSummaryResults?.length > 0) {
      <nh-table
        [columns]="burialResourcesSummaryColumns"
        [sectionId]="'PRASM'"
        [rows]="burialResourcesSummaryResults"
        [mode]="mode"
        (edit)="onBurialResourcesRowEdit($event)"
        (delete)="onBurialResourcesRowDelete($event)"
      >
      </nh-table>
      }
    </div>
  </div>
  <br />
  }
  @if (assetIndSw) {
  <div>
    <h2 class="section-header">Summary of Life Insurance </h2>
    <hr />
    <div>
      @if (!lifeInsuranceSummaryResults || lifeInsuranceSummaryResults?.length == 0) {
      <p>
        You haven't told us about any Life Insurance for your household.
      </p>
      } @if (lifeInsuranceSummaryResults && lifeInsuranceSummaryResults?.length > 0) {
      <nh-table
        [columns]="lifeInsuranceSummaryColumns"
        [sectionId]="'PRASM'"
        [rows]="lifeInsuranceSummaryResults"
        [mode]="mode"
        (edit)="onLifeInsuranceRowEdit($event)"
        (delete)="onLifeInsuranceRowDelete($event)"
      >
      </nh-table>
      }
    </div>
  </div>
  <br />
  }
  @if (assetIndSw) {
  <div>
    <h2 class="section-header">Summary of Other Resources </h2>
    <hr />
    <div>
      @if (!otherResourcesSummaryResults || otherResourcesSummaryResults?.length == 0) {
      <p>
        You haven't told us about any Other Resources for your household.
      </p>
      } @if (otherResourcesSummaryResults && otherResourcesSummaryResults?.length > 0) {
      <nh-table
        [columns]="otherResourcesSummaryColumns"
        [sectionId]="'PRASM'"
        [rows]="otherResourcesSummaryResults"
        [mode]="mode"
        (edit)="onOtherResourcesRowEdit($event)"
        (delete)="onOtherResourcesRowDelete($event)"
      >
      </nh-table>
      }
    </div>
  </div>
  <br />
  }

  <div class="py-3">
    <nh-checkbox
      name="applicationSignedBySw"
      [control]="getControl('data.applicationSignedBySw')"
      checkedValue="PARTNER_PORTAL"
      [mandatory]="true"
      label="Yes, I have reviewed all the above information with the applicant and confirm it is correct based on what I know."
      class="label-section"
    >
      @if (getControl('data.applicationSignedBySw').touched &&
      getControl('data.applicationSignedBySw').value === '' ||
      getControl('data.applicationSignedBySw').value === null) {
      <span class="form-text invalid-tooltip d-block"
        >Please answer the required field.</span
      >
      }
    </nh-checkbox>
  </div>
</nh-form>